import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import ITConsultantSection from './components/ITConsultantSection';
import SkillsSection from './components/SkillsSection';
import WebinarSection from './components/WebinarSection';
import ResourcesSection from './components/ResourcesSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <ITConsultantSection />
              <SkillsSection />
              <WebinarSection />
              <ResourcesSection />
            </>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;